import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const DateTimeMirroredIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M1792 993q60 41 107 93t81 114 50 131 18 141q0 119-45 224t-124 183-183 123-224 46q-91 0-176-27t-156-78-126-122-85-157H128V128h256V0h128v128h896V0h128v128h256v865zM256 256v256h1408V256h-128v128h-128V256H512v128H384V256H256zm643 1280q-3-31-3-64 0-86 24-167t73-153h-97v-128h128v86q41-51 91-90t108-67 121-42 128-15q100 0 192 33V640H256v896h643zm573 384q93 0 174-35t142-96 96-142 36-175q0-93-35-174t-96-142-142-96-175-36q-93 0-174 35t-142 96-96 142-36 175q0 93 35 174t96 142 142 96 175 36zm64-512h192v128h-320v-384h128v256zM384 1024h128v128H384v-128zm256 0h128v128H640v-128zm0-256h128v128H640V768zm0 512h128v128H640v-128zm384-384H896V768h128v128zm256 0h-128V768h128v128zM384 768h128v128H384V768z" />
    </svg>
  ),
  displayName: 'DateTimeMirroredIcon',
});

export default DateTimeMirroredIcon;
